import { Injectable } from "@angular/core";
import { DataService } from "../DataService/data.service";
import { Observable } from "rxjs";
import { IBaseData } from "src/app/Models/Interface/Base/base-data";
import { ISignIn } from "src/app/Models/Interface/Auth/sign-in";
import { APIName } from "../../Models/APIEndPoints/APIName";
import { ISignInResponse } from "src/app/Models/Interface/Auth/sign-in-response";
import { CookieService } from "ngx-cookie-service";
import { ISignInEventEmitterOBJ } from "../../Components/EventEmitterInterfaces/sign-in-event-emitter-obj";
import { ISetPassword } from "src/app/Models/Interface/Auth/set-password";
import { StorageOrderService } from "../ShopService/StorageOrder/storage-order.service";
import { IStorageOrder } from "src/app/Models/Interface/StorageOrder/storage-order";
import { EVariables } from "../../Models/Enum/variables";
import { UserDetailsService } from "../../Components/Services/user-details.service";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  loginOBJ = {} as ISignIn;
  setPasswordOBJ = {} as ISetPassword;
  voluntaryLogout = false;

  constructor(
    private dataService: DataService,
    private cookieService: CookieService,
    public storageOrderService: StorageOrderService,
    private userDetailsService: UserDetailsService
  ) {}

  login(
    loginOBJ: ISignInEventEmitterOBJ
  ): Observable<IBaseData<ISignInResponse>> {
    this.loginOBJ.Password = loginOBJ.password;
    this.loginOBJ.EmailAddress = loginOBJ.email;
    return this.dataService.post(APIName.auth.signIn, this.loginOBJ);
  }

  setCookie(userData: ISignInResponse): void {
    this.cookieService.set(
      "accountId",
      String(userData.accountId),
      undefined,
      "/"
    );
    this.cookieService.set(
      "accountTypeCode",
      String(userData.accountTypeCode),
      undefined,
      "/"
    );
    this.cookieService.set("companyName", userData.companyName, undefined, "/");
    this.cookieService.set(
      "currencyId",
      String(userData.currencyId),
      undefined,
      "/"
    );
    this.cookieService.set(
      "emailAddress",
      userData.emailAddress,
      undefined,
      "/"
    );
    this.cookieService.set("fullName", userData.fullName, undefined, "/");
    this.cookieService.set(
      "currencyCode",
      userData.currencyCode,
      undefined,
      "/"
    );
    this.cookieService.set(
      "isSuperAdmin",
      String(userData.isSuperAdmin),
      undefined,
      "/"
    );
    this.cookieService.set(
      "profilePicturePath",
      String(userData.profilePicturePath),
      undefined,
      "/"
    );
    this.cookieService.set("token", userData.token, undefined, "/");
    this.cookieService.set("userId", String(userData.userId), undefined, "/");
    this.cookieService.set("roleId", String(userData.roleId), undefined, "/");
    this.cookieService.set("roleCode", userData.roleCode, undefined, "/");
    this.cookieService.set(
      "userPermissionsLists",
      JSON.stringify(userData.userPermissionsLists),
      undefined,
      "/"
    );
    this.cookieService.set(
      "displayBoardingVideo",
      JSON.stringify(userData.displayBoardingVideo),
      undefined,
      "/"
    );
    this.cookieService.set(
      "seenBoardingVideo",
      JSON.stringify(true)
    );
  }

  setSession(userData: ISignInResponse): void {
    sessionStorage.setItem("accountId", String(userData.accountId));
    sessionStorage.setItem("accountTypeCode", String(userData.accountTypeCode));
    sessionStorage.setItem("companyName", userData.companyName);
    sessionStorage.setItem("currencyId", String(userData.currencyId));
    sessionStorage.setItem("emailAddress", userData.emailAddress);
    sessionStorage.setItem("fullName", userData.fullName);
    sessionStorage.setItem("currencyCode", userData.currencyCode);
    sessionStorage.setItem("isSuperAdmin", String(userData.isSuperAdmin));
    sessionStorage.setItem(
      "profilePicturePath",
      String(userData.profilePicturePath)
    );
    sessionStorage.setItem("token", userData.token);
    sessionStorage.setItem("userId", String(userData.userId));
    sessionStorage.setItem("roleId", String(userData.roleId));
    sessionStorage.setItem("roleCode", userData.roleCode);
    sessionStorage.setItem(
      "userPermissionsLists",
      JSON.stringify(userData.userPermissionsLists)
    );
    sessionStorage.setItem(
      "displayBoardingVideo",
      JSON.stringify(userData.displayBoardingVideo)
    );
    sessionStorage.setItem(
      "seenBoardingVideo",
      JSON.stringify(true)
    );
  }

  clearCookie(): void {
    this.cookieService.delete("fullName", "/");
    this.cookieService.delete("companyName", "/");
    this.cookieService.delete("accountTypeCode", "/");
    this.cookieService.delete("isSuperAdmin", "/");
    this.cookieService.delete("profilePicturePath", "/");
    this.cookieService.delete("token", "/");
    this.cookieService.delete("emailAddress", "/");
    this.cookieService.delete("accountId", "/");
    this.cookieService.delete("currencyId", "/");
    this.cookieService.delete("userId", "/");
    this.cookieService.delete("userPermissionsLists", "/");
    this.cookieService.delete("roleCode", "/");
    this.cookieService.delete("roleId", "/");
    this.cookieService.delete("currencyCode", "/");
    sessionStorage.clear();
  }

  setPassword(): Observable<any> {
    return this.dataService.post(APIName.user.setPassword, this.setPasswordOBJ);
  }

  logOut(): Observable<IBaseData<any>> {
    this.voluntaryLogout = true;
    if (
      localStorage.getItem(
        EVariables.Orders + this.userDetailsService.user.userId
      )
    ) {
      this.storageOrderService.order = {
        shoppingCart: [],
      } as unknown as IStorageOrder;
    }
    // localStorage.removeItem('isLogedIn')
    return this.dataService.post(APIName.user.logout, {});
  }
}
